import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const accordionHashTargets = () => {
    const hash = window.location.hash.slice(1);
    if (hash === '') {
        return [];
    }

    let decodedHash = hash;
    try {
        decodedHash = decodeURIComponent(hash);
    } catch (error) {
        // Conserva el fragmento original si no está codificado correctamente.
    }

    return decodedHash
        .split('#')
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .map((id) => document.getElementById(id))
        .filter((element) => element?.matches('.componente-acordeon-item'));
};

const showAccordionCollapse = (collapse) => new Promise((resolve) => {
    if (collapse.classList.contains('show')) {
        resolve();
        return;
    }

    const finish = () => {
        collapse.removeEventListener('shown.bs.collapse', finish);
        resolve();
    };

    collapse.addEventListener('shown.bs.collapse', finish, { once: true });
    bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false }).show();
    window.setTimeout(finish, 400);
});

const openAccordionItemFromHash = async () => {
    const targets = accordionHashTargets();
    const target = targets.at(-1);
    if (!target) {
        return;
    }

    const collapses = [];
    let parent = target.parentElement?.closest('.accordion-collapse');
    while (parent) {
        collapses.unshift(parent);
        parent = parent.parentElement?.closest('.accordion-collapse');
    }

    const targetCollapse = target.querySelector(':scope > .accordion-collapse');
    if (targetCollapse) {
        collapses.push(targetCollapse);
    }

    for (const collapse of collapses) {
        await showAccordionCollapse(collapse);
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

document.addEventListener('DOMContentLoaded', openAccordionItemFromHash);
window.addEventListener('hashchange', openAccordionItemFromHash);
